module.exports = __webpack_public_path__ + "img/7-6.55e7e7e2.png";